import type { ExtendedBusinessUser } from '../BizApi'
import { useLocale } from '@jotta/i18n'
import filesize from 'filesize'

export function BizDisplayStorage({
  storageBytes,
  quotaBytes,
}: Pick<ExtendedBusinessUser, 'storageBytes' | 'quotaBytes'>) {
  const locale = useLocale()
  const total =
    quotaBytes === undefined
      ? '∞'
      : filesize(Number(quotaBytes), {
          locale,
        })
  const used = filesize(Number(storageBytes), {
    locale,
  })
  if (!quotaBytes) {
    return (
      <>
        {used} / {total}
      </>
    )
  }
  const percentage =
    quotaBytes === undefined
      ? ''
      : Math.floor((Number(storageBytes) / Number(quotaBytes)) * 1000) / 10
  return (
    <>
      {percentage}% ({used} / {total})
    </>
  )
}
